import {
  DELETE_COOKIE_EXPIRATION,
  PERMANENT_COOKIE_EXPIRATION,
} from '@packages/domain/constants/cookies';

const findCookie = (name: any) => {
  const result = document.cookie
    .split(';')
    .map(cookie => cookie.trim())
    .filter(cookie => cookie.startsWith(`${name}=`));

  return result.length ? result[0] : undefined;
};

const extractValue = (cookie: any, name: any) =>
  decodeURIComponent(
    cookie
      .substring(name.length + 1)
      .split('+')
      .join(' '),
  );

export const cookies = {
  read: (name: any) => {
    const cookie = findCookie(name);
    if (cookie === undefined) {
      return null;
    }

    return extractValue(cookie, name);
  },

  set: (name: any, value: any, isPermanent: any, domain: any) => {
    const cookieExpiration = isPermanent
      ? `expires=${PERMANENT_COOKIE_EXPIRATION};`
      : '';
    const cookieDomain = domain ? `domain=${domain}` : '';

    const cookie = `${name}=${value}; ${cookieExpiration} path=/; ${cookieDomain}`;

    document.cookie = cookie;
  },

  delete: (name: any) => {
    const expires = DELETE_COOKIE_EXPIRATION;
    const cookie = `${name}=''; expires=${expires}; path=/`;

    document.cookie = cookie;
  },
};
